import {assignProps} from '@sail/engine';
import {useWidget} from '../Widget/useWidget';

function findAnchor(target: HTMLElement): HTMLAnchorElement | null {
  let node = target;
  // Only walk up 10 levels for performance. If we don't find it by
  // then, we very likely are not in an anchor tag
  for (let i = 0; i < 10; i += 1) {
    if (node?.tagName === 'A') {
      return node as HTMLAnchorElement;
    }
    node = node?.parentNode as HTMLElement;
  }
  return null;
}

export function widgetLinkAction() {
  return assignProps(() => {
    const widget = useWidget();

    return {
      target: '_blank',
      onClick: (e: MouseEvent) => {
        if (!e.target) {
          return;
        }

        // When clicking, elements inside the anchor tag can be
        // `e.target` if they were the thing clicked. We want the
        // actual anchor tag so we walk up the DOM tree to find it
        const anchor = findAnchor(e.target as HTMLElement);
        if (anchor == null) {
          return;
        }

        // Only fire an event for navigation if the following conditions
        // are met:
        //
        // * meta key isn't pressed (that should always open in a new window)
        // * The `href` points to a URL that has the same origin as
        //   the parent page (in the iframe case)
        //
        // Note that we will do this regardles of the `target`
        // property. If you always want to open the URL in a new tab,
        // you shouldn't need `widgetLinkAction` at all as this is
        // only to prefer client-side navigation
        if (
          !e.metaKey &&
          anchor.href &&
          anchor.href?.startsWith(document.location.ancestorOrigins[0])
        ) {
          e.preventDefault();
          widget.requestAction({name: 'navigate', data: {href: anchor.href}});
        }
      },
    };
  });
}
